<app-modal class="modal-overlay" *ngIf="showModal">
  <!-- Header do Modal -->
  <div class="modal-header">
    <div class="titulo-modal">
      <h2>Registrar entrada e saída de escola</h2>
    </div>
    <button class="btn-fechar-modal" (click)="closeModal()">✖</button>
  </div>
  <!-- Corpo do Modal -->
  <div class="modal-body">


    @if(userLogado?.autorizacaoUsoDados == 1){
      <button
        class="btn_segundario" (click)="getLocation()">
        Localização
      </button>

      <div>
        {{latitude}} - {{longitude}} - {{device}}
      </div>

    }

    <p class="descricao-modal">
      "Olá, {{this.userLogado?.nome}}! 👋 <br />
      Está na hora de registrar sua saída. Confirme os dados abaixo e clique em Registrar Saída para encerrar seu ponto do dia. Obrigado(a) pelo seu trabalho!"
    </p>
    <div class="row-escola">
      <img src="../../../assets/img/icons/icon-nome-escola.svg" title="URE" alt="">
      <p>
        <b>URE:</b> {{ this.escola.nomeDiretoria }}
      </p>
    </div>
    <div class="row-escola" *ngIf="this.escola.codigoEscola != 0">
      <img src="../../../assets/img/icons/icon-nome-escola.svg" title="Escala" alt="">
      <p>
        <b>Escola </b> {{ this.escola.codigoEscola }} -  {{ this.escola.nomeEscola }}
      </p>
    </div>
  </div>
    @if(deslocamento && deslocamento.totalKm > 1000){
        <form class="conteudo-textarea" [formGroup]="formDeslocamento">
          <label for="text-registro">Atenção! Você está a mais de 1km da escola, descreva o motivo.</label>
          <textarea
            id="text-registro"
            name="text-registro"
            rows="6"
            cols="50"
            formControlName="justificativaDistancia"
            [disabled]="disabledJustificativaDistancia"
            name="dsChamado"
            [ngClass]="{ 'is-invalid': submmited && !formDeslocamento.get('justificativaDistancia')?.value }"

            aria-describedby="descricao-error"
          ></textarea>
          <p class="legenda-textarea">Quantidade de caracteres atual: {{
            formDeslocamento.get('justificativaDistancia')?.value.length}}</p>
        </form>
      }
  <!-- Footer do Modal -->
  <div class="modal-footer">
    <div class="conteudo-btn-footer">
      <button class="btn_segundario" (click)="registraFimJornada()" [disabled]="submmited">
        Registrar Saída
      </button>
      <button class="btn_terciario" (click)="closeModal()">
        Fechar
      </button>
    </div>
  </div>
</app-modal>
